import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Shield, Trash2, Users, Loader2 } from "lucide-react";
import api, { apiErr } from "../lib/api";
import Btn from "../components/Btn";

export default function AdminGuilds() {
  const [guilds, setGuilds] = useState(null);
  const [busy, setBusy] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/admin/guilds"); setGuilds(data.guilds); }
    catch (e) { toast.error(apiErr(e)); setGuilds([]); }
  };
  useEffect(() => { load(); }, []);

  const del = async (g) => {
    if (!window.confirm(`Hapus guild "${g.name}"? Semua anggota (${g.members}) akan dikeluarkan dan riwayat perang/obrolan guild ini dihapus. Tindakan tidak bisa dibatalkan.`)) return;
    setBusy(g.guild_id);
    try {
      await api.delete(`/admin/guilds/${g.guild_id}`);
      toast.success(`Guild "${g.name}" dihapus`);
      load();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(null); }
  };

  if (!guilds) return <div className="min-h-[30vh] grid place-items-center"><Loader2 className="w-8 h-8 animate-spin text-su-primary" /></div>;

  return (
    <div className="card-chunky p-6" data-testid="admin-guilds">
      <h2 className="font-heading font-black text-lg mb-1 flex items-center gap-2"><Shield className="w-5 h-5 text-su-primary" /> Kelola Guild</h2>
      <p className="text-su-muted font-medium text-sm mb-4">Hapus guild yang tidak diinginkan (mis. guild dummy/lama). Anggotanya otomatis dikeluarkan.</p>

      {guilds.length === 0 ? (
        <p className="text-su-muted font-medium text-sm">Belum ada guild.</p>
      ) : (
        <div className="space-y-2">
          {guilds.map((g) => (
            <div key={g.guild_id} data-testid={`admin-guild-${g.guild_id}`} className="flex items-center gap-3 p-3 rounded-2xl border-2 border-su-border bg-su-surface">
              <span className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: `${g.emblem_color}22` }}>
                <Shield className="w-5 h-5" style={{ color: g.emblem_color }} />
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-heading font-black text-sm truncate">{g.name}</span>
                  {g.real_members === 0 && <span className="text-[10px] font-heading font-black uppercase bg-su-danger/15 text-su-danger px-2 py-0.5 rounded-full">Dummy</span>}
                  <span className="text-[10px] font-heading font-black uppercase bg-su-track text-su-muted px-2 py-0.5 rounded-full">{g.visibility === "private" ? "Privat" : "Publik"}</span>
                </div>
                <p className="text-xs text-su-muted font-medium flex items-center gap-1 mt-0.5">
                  <Users className="w-3 h-3" /> {g.members} anggota ({g.real_members} asli) · Ketua: {g.owner_name}{g.owner_is_dummy ? " (dummy)" : ""}
                </p>
              </div>
              <Btn variant="danger" size="sm" data-testid={`delete-guild-${g.guild_id}`} disabled={busy === g.guild_id} onClick={() => del(g)}>
                {busy === g.guild_id ? <Loader2 className="w-4 h-4 animate-spin" /> : <Trash2 className="w-4 h-4" />} Hapus
              </Btn>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
